// covered-by: packages/schemas/src/christo/__tests__/chatAtomComponentMap.test.ts
import chatAtomComponentMap from "./chatAtomComponentMap.json";

// why: `ask-puntt.chat-atom.*` ids live in @mg/schemas so rembrandt and carrie share one canonical list (see chatAtomComponentMap.json).
/**
 * Stable agent-referenceable IDs for Ask Puntt chat atoms (PR #5110).
 * Rembrandt / coordinator agents should emit these ids when selecting UI to render.
 */
export const CHAT_ATOM_AGENT_COMPONENT_IDS = {
  choiceRow: "ask-puntt.chat-atom.choice-row",
  questionFormCard: "ask-puntt.chat-atom.question-form-card",
  questionForm: "ask-puntt.chat-atom.question-form",
  reviewPreflight: "ask-puntt.chat-atom.review-preflight",
  enterpriseImpact: "ask-puntt.chat-atom.enterprise-impact",
  feedMemoryCard: "ask-puntt.chat-atom.feed-memory-card",
  reviewListCard: "ask-puntt.chat-atom.review-list-card",
  metricBlock: "ask-puntt.chat-atom.metric-block",
} as const;

export type ChatAtomAgentComponentId =
  (typeof CHAT_ATOM_AGENT_COMPONENT_IDS)[keyof typeof CHAT_ATOM_AGENT_COMPONENT_IDS];

export type ChatAtomAgentComponentDef = {
  id: ChatAtomAgentComponentId;
  component: string;
  sourceFile: string;
  description: string;
  whenToUse: string;
  keyProps: string[];
  variants?: string[];
};

/** DOM attribute agents and tests use to locate rendered chat atoms. */
export const AGENT_COMPONENT_ID_ATTR = "data-agent-component-id" as const;

export type ChatAtomAgentComponentInstanceId =
  `${ChatAtomAgentComponentId}.${string}`;

/** Per-row instance id when the same atom renders more than once on a surface. */
export function chatAtomAgentInstanceId(
  baseId: ChatAtomAgentComponentId,
  instanceKey: string,
): ChatAtomAgentComponentInstanceId {
  return `${baseId}.${instanceKey}`;
}

export function agentComponentIdAttr(
  id: ChatAtomAgentComponentId | ChatAtomAgentComponentInstanceId,
): { [AGENT_COMPONENT_ID_ATTR]: string } {
  return { [AGENT_COMPONENT_ID_ATTR]: id };
}

/** Authoritative map for AI agents — `chatAtomComponentMap.json` in this directory. */
export const CHAT_ATOM_AGENT_COMPONENT_MAP =
  chatAtomComponentMap as ChatAtomAgentComponentDef[];
